import React from 'react';
import { Evidence2 } from '@eas/common-web';
import { useColumns } from './notifications-columns';
import { ExportTags } from '../../enums/export-tags';
import { NotificationTemplate } from '../../models';
import { EvidenceAPI, PageKey } from '../../enums';
import { useDatedEvidence } from '../../components/evidence/dated-evidence/dated-evidence';
// import { NotificationTemplatesActionbar } from './notification-templates-actionbar';
import { usePermission } from '../../components/permission/perm-evidence-hook';
import { NotificationsFields } from './notifications-fields';
import { DetailEmptyActionbar } from '../../components/evidence/evidence/detail-empty-actionbar';
import { basicColoredFactory } from '../../components/form/basic-colored/basic-colored';

export function Notifications() {
  const columns = useColumns();

  const permissions = usePermission({
    options: {
      NEW: [],
      EDIT: [],
      REMOVE: [],
      CHECK: [],
      SAVE: [],
      CLOSE: [],
    },
  });

  const evidence = useDatedEvidence<NotificationTemplate>({
    identifier: PageKey.NOTIFICATIONS,
    apiProps: {
      url: EvidenceAPI.NOTIFICATIONS,
    },
    tableProps: {
      columns,
      columnLabelMapper: (column) => {
        if (column === 'CREATED') {
          return 'Datum odeslání';
        }
        return undefined;
      },
      showColumn: (column) => {
        if (column === 'UPDATED') {
          return false;
        }
        return true;
      },
      columnWrapper: basicColoredFactory,
      tableName: 'Přehled notifikací',
      reportTag: ExportTags.NOTIFICATIONS,
      showReportButton: false,
      defaultSorts: [],
    },
    detailProps: {
      FieldsComponent: NotificationsFields,
      toolbarProps: {
        title: 'Notifikace',
        ActionBar: DetailEmptyActionbar,
        showBtn: permissions,
      },
    },
  });

  return <Evidence2 {...evidence} />;
}
